// extracted by css-extract-rspack-plugin
export default {"bloko-media-marker":"bloko-media-marker","xs-friendly":"xs-friendly","s-friendly":"s-friendly"};